const dt = new Intl.DateTimeFormat('en-IN', {
  day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
})
const d = new Intl.DateTimeFormat('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })

export const formatDateTime = (v: unknown) => (v ? dt.format(new Date(v as string)) : '—')
export const formatDate = (v: unknown) => (v ? d.format(new Date(v as string)) : '—')

/** "3 minutes ago" for recent activity, an absolute date once it is old. */
export function relative(v: unknown): string {
  if (!v) return '—'
  const then = new Date(v as string).getTime()
  const mins = Math.round((Date.now() - then) / 60000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins} min ago`
  const hrs = Math.round(mins / 60)
  if (hrs < 24) return `${hrs} hr${hrs === 1 ? '' : 's'} ago`
  return d.format(new Date(v as string))
}
